import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KwFilterDropdownComponent } from './kw-filter-dropdown.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { NbCardModule, NbSpinnerModule } from '@nebular/theme';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { ColorPickerModule } from 'ngx-color-picker';
// import { NgxMaskModule } from 'ngx-mask';
import { TenantWordsModule } from '../../pipes/tenant-words.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    KwFilterDropdownComponent
  ],
  exports: [
    KwFilterDropdownComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    TenantWordsModule,
    FormsModule,
    NbCardModule,
    NgxMatSelectSearchModule,
    NbSpinnerModule,
    MatExpansionModule,
    AngularMultiSelectModule,
    FontAwesomeModule,
    MatButtonModule,
    MatTableModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,

    MatCheckboxModule,
    MatTableModule,
    ColorPickerModule,
    MatSortModule,
    MatIconModule,
    MatDividerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule
  ]
})
export class KwFilterDropdownModule { }
